import { Input } from 'antd';
import styled from 'styled-components';

export const CustomInputStyled = styled(Input)`
  height: 40px;
  font-size: 16px;
  margin-bottom: 20px;
  border-radius: 8px;
`;
